import { render, staticRenderFns } from "./UniversalButton.vue?vue&type=template&id=68baa5dc&scoped=true"
import script from "./UniversalButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UniversalButton.vue?vue&type=style&index=0&id=68baa5dc&prod&scoped=true&lang=css"
import style1 from "./UniversalButton.vue?vue&type=style&index=1&id=68baa5dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baa5dc",
  null
  
)

export default component.exports